var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useIntl } from 'react-intl';
var BADGE_STYLE = {
    backgroundColor: '#fff8e1',
    border: '1px solid #ffca28',
    color: '#6d4c00',
    padding: '2px 6px',
    fontSize: '0.85em',
    borderRadius: '4px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
};
/**
 * CZNA-1519 — "Návrh změny: <stav>" on an authority that has an amendment in progress, in the
 * authority list and in the register, so a cataloguer sees it before opening the authority
 * (the detail has listed it since CZNA-1476). One mark per amendment, each with its own status.
 * Display only: the row opens the detail, which links the amendment.
 *
 * Renders nothing when there is none, so an unmarked row looks exactly as before.
 */
/** A box rather than inline text, so a second line keeps the badge's padding and border. */
var WRAPPING_BADGE_STYLE = __assign(__assign({}, BADGE_STYLE), { display: 'inline-block', whiteSpace: 'normal', wordBreak: 'normal', overflowWrap: 'normal' });
export var OpenProposalBadges = function (_a) {
    var proposals = _a.proposals, _b = _a.wrapWords, wrapWords = _b === void 0 ? false : _b;
    var intl = useIntl();
    if (!proposals || proposals.length === 0) {
        return null;
    }
    return (React.createElement("span", { style: { display: 'inline-flex', flexWrap: 'wrap', gap: '4px' } }, proposals.map(function (proposal) { return (React.createElement("span", { key: proposal.id, "data-testid": "open-proposal-badge", "data-proposal-status": proposal.status, title: proposal.authorityId, style: wrapWords ? WRAPPING_BADGE_STYLE : BADGE_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.authorities.openProposal.badge' }, {
        status: intl.formatMessage({
            id: "ui-czna-authorities.authorities.proposalStatus.".concat(proposal.status),
        }),
    }))); })));
};
export default OpenProposalBadges;
